// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.calendar {
  padding-bottom: 75%;
  position: relative;
  height: 0;
  overflow: hidden;
}
  div.calendar-agenda {
    padding-bottom: 90%;
  }

  div > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`, "",{"version":3,"sources":["webpack://./src/app/calendar/calendar.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;EACd","sourcesContent":["div.calendar {\r\n  padding-bottom: 75%;\r\n  position: relative;\r\n  height: 0;\r\n  overflow: hidden;\r\n}\r\n  div.calendar-agenda {\r\n    padding-bottom: 90%;\r\n  }\r\n\r\n  div > iframe {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
